import { useHttpClientDispatchable } from "../../../common/modules/httpClient/hooks/useHttpClientDispatchable";
import { RequestMethodEnum } from "../../../common/modules/httpClient/enums/RequestMethodEnum";

export const useVerifyUserMailService = () => {
  return useHttpClientDispatchable({
    url: "/user/account/verifyEmail",
    method: RequestMethodEnum.POST,
  });
};
